module.exports = __webpack_public_path__ + "assets/19fb59bd93fdec653d72ddbeea0878bd.svg";